module.exports = {
  dateTime: '2019-09-26',
  day: '26',
  month: 'Sep',
  monthFull: 'September',
  year: '2019',
};
